"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getNodeText = exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _index = require("./index");
const getNodeText = function (node) {
  var _node$props, _node$props2;
  if (["string", "number"].includes(typeof node)) {
    const text = (0, _index.purifyText)(String(node));
    return text;
  }
  if (node instanceof Array) {
    const results = [];
    node.forEach(function (element) {
      const text = getNodeText(element);
      if ((text === null || text === void 0 ? void 0 : text.length) > 0) results.push(text);
    });
    return results.join(" ");
  }
  if (typeof node === "object" && node) return getNodeText((_node$props = node.props) === null || _node$props === void 0 ? void 0 : _node$props.text) || getNodeText((_node$props2 = node.props) === null || _node$props2 === void 0 ? void 0 : _node$props2.children);
};
exports.getNodeText = getNodeText;
var _default = exports.default = getNodeText;